import type { ExtractedPosting } from '../types'
import { supabase } from './supabaseClient'
import { PRESET_STAGE_OPTIONS } from './stagePresets'

type ExtractedPostingWithDraft = ExtractedPosting & {
  draftId?: string
  isDraft?: boolean
}

export const extractJobFromUrl = async (
  url: string, 
  saveAsDraft = false
): Promise<ExtractedPostingWithDraft> => {
  if (!/^https?:\/\//i.test(url)) throw new Error('Please provide a valid URL.')

  const { data, error } = await supabase.functions.invoke<ExtractedPostingWithDraft>('extract-job', {
    body: { url, save_as_draft: saveAsDraft },
  })

  if (error) {
    const message = typeof error === 'string' ? error : error.message ?? 'Failed to fetch data.'
    throw new Error(message)
  }
  if (!data) {
    throw new Error('No data returned from the Edge Function.')
  }

  const salaryRange = data.salaryRange
  const salaryPeriod = data.salaryPeriod ?? salaryRange?.period ?? null
  const normalizedSalary =
    salaryRange && salaryRange.min != null && salaryRange.max != null
      ? {
          min: Number(salaryRange.min),
          max: Number(salaryRange.max),
          currency: salaryRange.currency ?? 'PLN',
          period: salaryPeriod,
        }
      : null

  return {
    company: data.company || 'N/D',
    companyId: data.companyId ?? null,
    companyInfo: data.companyInfo ?? null,
    positionTitle: data.positionTitle ?? null,
    salaryRange: normalizedSalary,
    salaryPeriod,
    techStack: Array.isArray(data.techStack) ? data.techStack : [],
    stages: Array.isArray(data.stages) && data.stages.length > 0 ? data.stages : [...PRESET_STAGE_OPTIONS],
    contractType: data.contractType ?? null,
    benefits: data.benefits ?? null,
    workMode: data.workMode ?? null,
    officeDays: data.officeDays ?? null,
    rawMarkdown: data.rawMarkdown ?? null,
    draftId: data.draftId,
    isDraft: data.isDraft,
  }
}

